import ProjectDetailsForm from './ProjectDetailsForm';

export default ProjectDetailsForm;
